var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVuejsLogowine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 800,
    width: 1200,
    viewBox: "-39.26295 -56.672 340.2789 340.032",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#41b883",
    d: "M161.101 0l-30.224 52.35L100.652 0H0l130.877 226.688L261.753 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#34495e",
    d: "M161.101 0l-30.224 52.35L100.652 0H52.351l78.526 136.01L209.403 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuejsLogowine);
export default __webpack_public_path__ + "static/media/Vue.js-Logo.wine.0c16ab8d82a7895d2b2b7fad029f5796.svg";
export { ForwardRef as ReactComponent };